import api from './api';

export interface ReplyAnalysis {
  category: string;
  intent: string;
  tone: string;
  urgency: number;
  decisionMaker: string;
  responses: Array<{ style: string; draft: string }>;
  avoid: string[];
  nextSteps: { immediate: string; ifNoResponse: string };
}

export interface AnalyzeReplyResult {
  analysis: ReplyAnalysis | null;
  raw?: string;
  provider: string;
  model: string;
}

export interface InboundReply {
  id: string;
  source: string;
  type?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  lemlistCampaignId?: string | null;
  campaignName?: string | null;
  text?: string | null;
  handled: boolean;
  receivedAt: string;
}

/** Vorschlag im Clearing: Mandant samt Grund (Kampagne, Lead). */
export interface ClearingKandidat {
  tenantId: string;
  name: string;
  grund: string;
}

/** Antwort ohne Mandant -- nur fuer Plattform-Admins (admin.mandant.alle). */
export interface ClearingFall extends InboundReply {
  kandidaten: ClearingKandidat[];
}

class ReplyService {
  async analyze(reply: string, offerId?: string, context?: string): Promise<AnalyzeReplyResult> {
    const response = await api.post('/replies/analyze', { reply, offerId, context });
    return response.data;
  }

  async getInbox(handled?: boolean): Promise<InboundReply[]> {
    const response = await api.get('/replies/inbox', {
      params: handled === undefined ? {} : { handled },
    });
    return response.data;
  }

  async markHandled(id: string, handled = true): Promise<InboundReply> {
    const response = await api.patch(`/replies/inbox/${id}`, { handled });
    return response.data;
  }

  async getClearing(): Promise<ClearingFall[]> {
    const response = await api.get('/replies/clearing');
    return response.data;
  }

  async getClearingAnzahl(): Promise<number> {
    const response = await api.get('/replies/clearing/anzahl');
    return response.data?.anzahl ?? 0;
  }

  async clearingZuweisen(id: string, tenantId: string): Promise<InboundReply> {
    const response = await api.post(`/replies/clearing/${id}`, { tenantId });
    return response.data;
  }

  async clearingAutomatisch(): Promise<{ geprueft: number; zugeordnet: number }> {
    const response = await api.post('/replies/clearing/auto');
    return response.data;
  }

  async createTestReply(): Promise<InboundReply> {
    const response = await api.post('/replies/inbox/test');
    return response.data;
  }
}

const replyService = new ReplyService();
export default replyService;
